import { makeStyles } from "@material-ui/core";

export default makeStyles(({ spacing, breakpoints, palette }) => ({
    card: {
        boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.08)",
        width: "420px"
    },
    cardHeader: {
        height: "52px",
        backgroundColor: palette.mainText.main,
        color: "white",
        alignItems: "center",
        borderRadius: "5px 5px 0px 0px"
    },
    headerText: {
        paddingLeft: spacing(3)
    },
    actionSection: {
        height: "47px",
        backgroundColor: palette.inputTableDivider.main,
        alignItems: "center"
    },
    reportLine: {
        paddingLeft: spacing(3),
        paddingTop: spacing(2),
        alignItems: "center"
    },
    reportText: {
        paddingLeft: spacing(1)
    },

}));